export const stopMouseEventPropagation =
    (condition = true) =>
    (e: React.MouseEvent) => {
        if (condition) {
            e.stopPropagation();
        }
    };
